import { SavedSearchApiManager } from './api';
import { SavedSearchStorageApiManager } from './storage-api';
import { ThemeNames } from 'types/themes';
import type { SavedSearch } from './types';
export type { SavedSearch as default };

/**
 * Feature flag for the saved-search backend cutover. When enabled, all reads AND
 * writes go through the DynamoDB-backed storage service (via the /api/saved-searches
 * proxy); otherwise they use the legacy client-app /services/api/v3/saved-searches API.
 *
 * This is an all-or-nothing per-environment switch so reads and writes always hit
 * the same backend within a session. Flip NEXT_PUBLIC_SAVED_SEARCH_USE_STORAGE_SERVICE
 * to "true" to roll forward; unset/anything else falls back to the legacy path.
 */
function shouldUseStorageService(): boolean {
  return process.env.NEXT_PUBLIC_SAVED_SEARCH_USE_STORAGE_SERVICE === 'true';
}

function savedSearchManager() {
  return shouldUseStorageService() ? SavedSearchStorageApiManager : SavedSearchApiManager;
}

export async function getSavedSearches(pageSize: number, pageNumber?: number, source: ThemeNames = ThemeNames.ZOOCASA) {
  return savedSearchManager().get({ page: { size: pageSize, number: pageNumber }, source });
}

export async function createSavedSearch(search: Partial<SavedSearch>) {
  return savedSearchManager().create(search);
}

export async function deleteSavedSearch(id: string) {
  return savedSearchManager().delete(id);
}

export async function updateSavedSearch(search: Partial<SavedSearch>) {
  return SavedSearchApiManager.update(search);
}

export async function getSavedSearchNewListingsCount(id: string, timestamp: string) {
  return SavedSearchApiManager.getNewListingsCountSince(id, timestamp);
}
